// extracted by mini-css-extract-plugin
module.exports = {"section":"hero_section__5gGqK","content":"hero_content___t2U_","description":"hero_description__aXdFK"};